
import { defineComponent, reactive, ref } from 'vue';
import TeacherModules from './js/modules';

const component = defineComponent({
  name: 'teacher-homepage',
  setup() {
    const teacherModules = reactive(new TeacherModules());
    const diavisiable = ref(false);

    return {
      teacherModules, diavisiable,
    };
  },
});

export default component;
